import moment from "moment";

export const isValidTextInput = (value) => {
  const regex = /^[A-Za-z\s]*$/;
  return regex.test(value);
};

export const isValidNameWithSpecialChars = (value) => {
  const regex = /^[A-Za-z\s'-]*$/;
  return regex.test(value);
};

export const isValidNumberInput = (value) => {
  const regex = /^[0-9]*$/;
  return regex.test(value);
};

export const isValidDecimalInput = (value) => {
  // Regex to allow numbers with optional decimal and up to two digits after the decimal
  const regex = /^\d*(\.\d{0,2})?$/;
  return regex.test(value);
};

export const formatDate = (date) => {
  // Use moment.js to format the input date
  const formattedDate = moment(date).format("MMM D, YYYY");

  // Check if the date is valid, return 'Invalid date' if not
  if (!moment(date).isValid()) {
    return "Invalid date";
  }

  return formattedDate;
};

export const isoDateFormat = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

// Allows only alphanumeric & spaces
export const isValidAlphaNumeric = (name) => {
  const regex = /^[a-zA-Z0-9 ]*$/;
  return regex.test(name);
};

// calculate the macronutrients based on the total calories and their respective percentages
export const calculateMacronutrients = (
  totalCalories,
  proteinPercentage,
  carbPercentage,
  fatPercentage
) => {
  // Calculate Protein, Carbs, and Fats based on the given percentages
  const proteinGrams = (totalCalories * proteinPercentage) / 100 / 4;
  const carbGrams = (totalCalories * carbPercentage) / 100 / 4;
  const fatGrams = (totalCalories * fatPercentage) / 100 / 9;

  return {
    protein: proteinGrams,
    carbs: carbGrams,
    fat: fatGrams,
  };
};

// messenger date time

export const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isYesterday = (date) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

// Only show time (e.g. 12:45 PM)
export const formatTime = (date) =>
  new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

// Compare if the day has changed
export const isNewDay = (current, last) => {
  if (!last) return true;
  return (
    current.getDate() !== last.getDate() ||
    current.getMonth() !== last.getMonth() ||
    current.getFullYear() !== last.getFullYear()
  );
};

// Helper function to check if a message was sent today
export const isMessageFromToday = (messageDate) => {
  const today = new Date();
  const msgDate = new Date(messageDate);
  return (
    msgDate.getDate() === today.getDate() &&
    msgDate.getMonth() === today.getMonth() &&
    msgDate.getFullYear() === today.getFullYear()
  );
};

export const normalizeMealTime = (mealTimeStr) => {
  return mealTimeStr.replace(/[0-9]/g, ""); // removes any digits
};
// mealplan summary
export const regexUnitFind = (str) => {
  const regex =
    /(\.?\d*)\s*(mg|µg|mcg|mg\/day|g\/day|µg\/day|mcg\/day|IU|kcal|kj)/i;
  return regex.exec(str);
};

export const formatNutrientKey = (key) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};

// Helper function to handle both Date objects and YYYY-MM-DD strings
export const normalizeDateForAPI = (date) => {
  try {
    if (!date) return "";

    // If it's already in YYYY-MM-DD format, return as-is
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    // If it's a Date object, format to YYYY-MM-DD
    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    return "";
  } catch (error) {
    console.error("Error normalizing date:", error);
    return "";
  }
};
//normalizeTitle function to format strings for consistency
export const normalizeTitle = (s = "") =>
  s
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, " ")
    .replace(/[^a-z0-9 ]/g, "")
    .trim();
